import React from "react";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Global Talent, Simplified.</h1>
        <p>
          We connect ambitious businesses with top-tier Sri Lankan professionals.
          Build your dream team remotely while we handle the rest.
        </p>
        <button>Schedule a Free Consultation</button>
        <button>Schedule a Free Consultation</button>
      </div>
    </section>
  );
}

export default Hero;